export default __webpack_public_path__ + "static/media/icons-mail-navigation-black.d924e3e8.svg";